var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1286_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.896 15.3518C16.7145 15.771 16.4997 16.1569 16.2508 16.5117C15.9116 16.9954 15.6338 17.3302 15.4197 17.5161C15.0879 17.8213 14.7323 17.9776 14.3516 17.9865C14.0783 17.9865 13.7487 17.9087 13.365 17.751C12.98 17.5939 12.6263 17.5161 12.3028 17.5161C11.9635 17.5161 11.5997 17.5939 11.2105 17.751C10.8208 17.9087 10.5068 17.9909 10.2667 17.9991C9.90161 18.0147 9.5377 17.8539 9.17445 17.5161C8.9426 17.3139 8.65261 16.9673 8.30522 16.4762C7.93249 15.9517 7.62605 15.3436 7.38599 14.6503C7.12888 13.9014 7 13.1763 7 12.4742C7 11.67 7.17377 10.9764 7.52184 10.3952C7.79538 9.9283 8.1593 9.56002 8.61476 9.28965C9.07023 9.01929 9.56236 8.88152 10.0923 8.8727C10.3823 8.8727 10.7626 8.9624 11.2352 9.1387C11.7064 9.31558 12.009 9.40528 12.1417 9.40528C12.2409 9.40528 12.577 9.30039 13.1468 9.09129C13.6857 8.89737 14.1405 8.81708 14.5131 8.8487C15.5227 8.93018 16.2812 9.32817 16.7856 10.0452C15.8827 10.5923 15.436 11.3586 15.4449 12.3416C15.4531 13.1072 15.7308 13.7444 16.2767 14.2503C16.5241 14.4851 16.8004 14.6666 17.1078 14.7955C17.0412 14.9888 16.9708 15.174 16.896 15.3518ZM14.5805 6.24019C14.5805 6.84033 14.3612 7.40067 13.9242 7.91932C13.3968 8.5359 12.7589 8.89218 12.0672 8.83596C12.0584 8.76397 12.0532 8.68819 12.0532 8.60856C12.0532 8.03243 12.3041 7.41586 12.7494 6.91173C12.9718 6.65647 13.2546 6.44424 13.5976 6.27493C13.9398 6.10815 14.2635 6.01592 14.5679 6.00012C14.5768 6.08035 14.5805 6.16059 14.5805 6.24018V6.24019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1286_1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ef8812464289827548bdbc337c7b622e.svg";
export { ForwardRef as ReactComponent };